export const getSpecialties = ({ clinic, providers }) => {
  const providersToUse = providers || clinic.providers;

  const allSubSpecialties =
    providersToUse
      ?.map(provider => provider.specialties)
      .flat()
      .map(subSpecialty => subSpecialty.specialty) || [];

  // Unique specialties by ID
  const uniqueSpecialties = allSubSpecialties
    .filter(
      (specialty, index) =>
        index === allSubSpecialties.findIndex(t => t.id === specialty.id),
    )
    .sort((a, b) => a.name.localeCompare(b.name));

  return uniqueSpecialties;
};

export const getRequestedSpecialties = match =>
  match?.other?.specialistData?.specialistTypes || [];

export const clinicHasRequestedSpecialty = ({ clinic, providers, match }) => {
  const uniqueSpecialties = getSpecialties({ clinic, providers });
  const requestedSpecialties = getRequestedSpecialties(match);

  return isRequestedSpecialtyOffered(uniqueSpecialties, requestedSpecialties);
};

export const isRequestedSpecialtyOffered = (
  offeredSpecialties = [],
  requestedSpecialties = [],
) =>
  requestedSpecialties.some(requestedSpecialty =>
    offeredSpecialties.some(s => requestedSpecialty.dbId === s.id)) || false;

export const getRequestedSpecialtiesOffered = (
  offeredSpecialties = [],
  requestedSpecialties = [],
) =>
  requestedSpecialties.filter(requestedSpecialty =>
    offeredSpecialties.some(s => requestedSpecialty.dbId === s.id));

export const findLastIndexOfClinicWithRequestedSpecialty = ({
  clinics,
  match,
}) => {
  const requestedSpecialties = getRequestedSpecialties(match);

  return clinics
    .map(clinic => getSpecialties({ clinic }))
    .findLastIndex(clinicSpecialties =>
      isRequestedSpecialtyOffered(clinicSpecialties, requestedSpecialties));
};

export const doesProviderOfferSpecialty = (provider, specialty) =>
  provider.specialties.some(
    s => (s.specialty?.id || s.specialty) === (specialty.id || specialty),
  );
